<template>
  <div>
    <b-breadcrumb class="breadcrumb-slash mb-1">
      <b-breadcrumb-item :to="{ name: 'dashboard-1' }">
        {{ $t("HomePage.HomePage") }}
        <!-- Dashboard -->
      </b-breadcrumb-item>
      <b-breadcrumb-item active>
        {{ $t("OrderListDetails.OrderDetails") }}
        <!-- ข้อมูลคำสั่งซื้อ -->
      </b-breadcrumb-item>
    </b-breadcrumb>

    <section class="invoice-preview-wrapper">
      <b-row class="invoice-preview">
        <!-- Col: Left (Invoice Container) -->
        <b-col
          cols="12"
          xl="9"
          md="8"
        >
          <b-card
            no-body
            class="invoice-preview-card"
          >
            <!-- Header -->
            <b-card-body class="invoice-padding pb-0">
              <b-row>
                <b-col cols="6">
                  <b-row>
                    <b-col>
                      <h5 class="text-primary">
                        {{ $t("OrderListDetails.ShopName") }}
                        <!-- ชื่อร้านค้า :  -->
                        {{ orderModel.shopName }}
                      </h5>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col>
                      <h6>
                        {{ orderModel.shopAddress }}
                      </h6>
                    </b-col>
                  </b-row>
                </b-col>

                <b-col>
                  <b-row>
                    <b-col cols="5">
                      <h5>
                        {{ $t("OrderListDetails.OrderNumber") }}
                        <!-- หมายเลขคำสั่งซื้อ : -->
                      </h5>
                    </b-col>
                    <b-col>
                      <h5>
                        {{ orderModel.no }}
                      </h5>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="5">
                      <h5>
                        {{ $t("OrderListDetails.BookingNumber") }}
                        <!-- หมายเลข Booking -->
                      </h5>
                    </b-col>
                    <b-col>
                      <h5>
                        {{ orderModel.trackingID }}
                      </h5>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="5">
                      <h6>
                        {{ $t("OrderListDetails.OrderDate") }}
                        <!-- วันที่สั่งซื้อ : -->
                      </h6>
                    </b-col>
                    <b-col>
                      <h6>
                        {{ orderModel.createdOnString }}
                      </h6>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="5">
                      <h6>
                        {{ $t("OrderListDetails.OrderStatus") }}
                        <!-- สถานะการสั่งซื้อ : -->
                      </h6>
                    </b-col>
                    <b-col>
                      <h6>
                        {{ orderModel.orderStatusString }}
                      </h6>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-card-body>

            <hr class="invoice-spacing">

            <b-card-body class="invoice-padding pt-0">
              <b-row>
                <b-col cols="6">
                  <b-row>
                    <b-col>
                      <h5>
                        {{ $t("OrderListDetails.ConsigneeName") }}
                        <!-- ชื่อผู้รับสินค้า :  -->
                        {{ orderModel.shippingAddress.contactName }}
                      </h5>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col>
                      <h6>
                        {{ orderModel.customerAddress }}
                      </h6>
                    </b-col>
                  </b-row>
                </b-col>

                <b-col>
                  <b-row>
                    <b-col>
                      <h5>
                        {{ $t("OrderListDetails.PaymentDetails") }}
                        <!-- รายละเอียดการชำระเงิน : -->
                      </h5>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="6">
                      <h6>
                        {{ $t("OrderListDetails.AllPayments") }}
                        <!-- การชำระเงินทั้งหมด : -->
                      </h6>
                    </b-col>
                    <b-col>
                      <h6>
                        {{ orderModel.orderTotal.toLocaleString("en-US") }} {{ $t("OrderListDetails.Baht") }}
                        <!-- บาท -->
                      </h6>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="6">
                      <h6>
                        {{ $t("OrderListDetails.PaymentMethod") }}
                        <!-- วิธีการชำระเงิน : -->
                      </h6>
                    </b-col>
                    <b-col>
                      <h6>
                        {{ orderModel.paymentMethodString }}
                      </h6>
                    </b-col>
                  </b-row>

                  <!-- รายละเอียดการชำระเงิน : -->
                  <!-- <b-row>
                    <b-col cols="6">
                      <h6>
                        {{ $t("OrderListDetails.PaymentDetails") }}

                      </h6>
                    </b-col>
                    <b-col>
                      <h6 />
                    </b-col>
                  </b-row> -->
                </b-col>
              </b-row>
            </b-card-body>

            <!-- Table -->
            <b-table-lite
              v-if="orderModel.orderStatusString == 'Paid' || orderModel.orderStatusString == 'Pending Payment'"
              responsive
              :items="orderModel.items"
              :fields="[
                { key: 'name', label: $t('OrderListDetails.ProductName') },
                {
                  key: 'productPrice',
                  label: $t('OrderListDetails.PricePerPiece'),
                },
                { key: 'quantity', label: $t('OrderListDetails.Quantity') },
                { key: 'itemAmount', label: $t('OrderListDetails.TotalPrice') },
                { key: 'action', label: '' },
              ]"
            >
              <template #cell(name)="data">
                <div style="width: 10rem">
                  {{ data.item.name }}
                </div>
              </template>
              <template #cell(productPrice)="data">
                <span>{{
                        data.item.productPrice.toLocaleString("en-US")
                      }}
                  {{ $t("OrderListDetails.Baht") }}
                  <!-- บาท --></span>
              </template>
              <template #cell(quantity)="data">
                <span>{{ data.item.quantity.toLocaleString("en-US") }} </span>
              </template>
              <template #cell(itemAmount)="data">
                <span>{{ data.item.itemAmount.toLocaleString("en-US") }} {{ $t("OrderListDetails.Baht") }}
                  <!-- บาท --></span>
              </template>
              <template #cell(action)="data">
                <span v-if="orderModel.orderStatusString == 'Delivery'">
                  <b-button
                    v-show="orderModel.orderStatusString == 'Delivery'"
                    v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                    style="width: 10rem"
                    variant="primary"
                    class="mb-75"
                    block
                    @click="printLabel(data)"
                  >
                    {{ $t("OrderListDetails.PrintCoverSheet") }}
                    <!-- พิมพ์ใบปะหน้า -->
                  </b-button>
                  <!-- {{ data.item.jobID }} -->
                </span>
                <span v-else />
              </template>
            </b-table-lite>

            <b-table-lite
              v-else
              responsive
              :items="trackersList"
              :fields="[
                { key: 'trackingID_oms', label: $t('OrderListDetails.BoxCode')},
                { key: 'product_id.product_name', label: $t('OrderListDetails.ProductName') },
                {
                  key: 'product_id.price',
                  label: $t('OrderListDetails.PricePerPiece'),
                },
                { key: 'qtyInBox', label: $t('OrderListDetails.Quantity') },
                { key: 'product_price_per_box', label: $t('OrderListDetails.TotalPrice') },
                { key: 'status_Code', label: 'สถานะจัดส่ง' },
                // status_Code
                { key: 'action', label: '' },
              ]"
            >
              <template #cell(name)="data">
                <div style="width: 10rem">
                  {{ data.item.name }}
                </div>
              </template>
              <template #cell(status_Code)="data">
                <div style="width: 10rem">
                  {{ GetStatusName(data.item.status_Code) }}
                </div>
              </template>
              <template #cell(productPrice)="data">
                <span>{{
                        data.item.productPrice.toLocaleString("en-US")
                      }}
                  {{ $t("OrderListDetails.Baht") }}
                  <!-- บาท --></span>
              </template>
              <template #cell(quantity)="data">
                <span>{{ data.item.quantity.toLocaleString("en-US") }} </span>
              </template>
              <template #cell(itemAmount)="data">
                <span>{{ data.item.itemAmount.toLocaleString("en-US") }} {{ $t("OrderListDetails.Baht") }}
                  <!-- บาท --></span>
              </template>
              <template #cell(action)="data">
                <span v-if="orderModel.orderStatusString == 'Delivery'">
                  <b-button
                    v-show="orderModel.orderStatusString == 'Delivery'"
                    v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                    style="width: 8rem"
                    variant="primary"
                    class="mb-75"
                    block
                    @click="printLabel(data)"
                  >
                    {{ $t("OrderListDetails.PrintCoverSheet") }}
                    <!-- พิมพ์ใบปะหน้า -->
                  </b-button>
                  <!-- {{ data.item.jobID }} -->
                </span>
                <span v-else />
              </template>
            </b-table-lite>
            <b-card-body class="invoice-padding pb-0">
              <b-row>
                <b-col cols="4" />

                <b-col>
                  <h6>
                    {{ $t("OrderListDetails.TotalOfAllProducts") }}
                    <!-- ยอดรวมทั้งหมด : -->
                  </h6>
                </b-col>
                <b-col>
                  <h6>{{ orderModel.itemsTotal }} {{ $t("OrderListDetails.Piece") }}</h6>
                </b-col>
                <b-col>
                  <h6>{{ orderModel.subTotal.toLocaleString("en-US") }} {{ $t("OrderListDetails.Baht") }}
                    <!-- บาท --></h6>
                </b-col>
              </b-row>

              <b-row class="mt-2">
                <b-col cols="6">
                  <b-row>
                    <b-col cols="5">
                      <h6>
                        {{ $t("OrderListDetails.NameofEmployee/Shop") }}
                        <!-- ชื่อพนักงาน/ ร้านค้า : -->
                      </h6>
                    </b-col>
                    <b-col>
                      <h6>
                        {{ orderModel.employeeShop }}
                      </h6>
                    </b-col>
                  </b-row>
                </b-col>

                <b-col>
                  <!-- จำนวนสินค้าทั้งหมด : -->
                  <b-row>
                    <b-col cols="6">
                      <h5>
                        {{ $t("OrderListDetails.TotalNumberOfProducts") }}
                      </h5>
                    </b-col>
                    <b-col>
                      <h5>
                        {{ orderModel.itemsTotal.toLocaleString("en-US") }} {{ $t("OrderListDetails.Piece") }}
                        <!-- ชิ้น -->
                      </h5>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="6">
                      <h5>
                        {{ $t("OrderListDetails.TotalOfAllProducts") }}
                        <!-- ยอดรวมสินค้าทั้งหมด : -->
                      </h5>
                    </b-col>
                    <b-col>
                      <h5>
                        {{ orderModel.subTotal.toLocaleString("en-US") }} {{ $t("OrderListDetails.Baht") }}
                        <!-- บาท -->
                      </h5>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="6">
                      <h6>
                        {{ $t("OrderListDetails.ShippingCost") }}
                        <!-- ค่าจัดส่งสินค้า : -->
                      </h6>
                    </b-col>
                    <b-col>
                      <h6>
                        {{
                          orderModel.shippingFeeAmount.toLocaleString("en-US")
                        }}
                        {{ $t("OrderListDetails.Baht") }}
                        <!-- บาท -->
                      </h6>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="6">
                      <h6>
                        {{ $t("OrderListDetails.AllPayments") }}
                        <!-- การชำระเงินทั้งหมด : -->
                      </h6>
                    </b-col>
                    <b-col>
                      <h6>
                        {{ orderModel.orderTotal.toLocaleString("en-US") }} {{ $t("OrderListDetails.Baht") }}
                        <!-- บาท -->
                      </h6>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-card-body>

            <!-- Spacer -->
            <hr class="invoice-spacing">

            <!-- Note -->
            <b-card-body class="invoice-padding pt-0">
              <span class="font-weight-bold">
                {{ $t("OrderListDetails.Remark") }}
                <!-- หมายเหตุ :  -->
              </span>
              <span />
            </b-card-body>
          </b-card>
        </b-col>

        <!-- Right Col: Card -->
        <b-col
          cols="12"
          md="4"
          xl="3"
          class="invoice-actions"
        >
          <b-card>
            <!-- Button: DOwnload -->
            <!-- <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="outline-secondary"
              class="mb-75"
              block
            >
              ดาวน์โหลด
            </b-button> -->

            <!-- Button: Print -->

            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              v-b-modal.modal-cancel-order
              variant="primary"
              class="mb-75"
              block
            >
              {{ $t("OrderListDetails.Cancel") }}
              <!-- ยกเลิก -->
              <!-- ยกเลิก -->
            </b-button>
            <!-- <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="outline-secondary"
              class="mb-75"
              block
              @click="printInvoice"
            >
              {{ $t("OrderListDetails.PrintCover/LetterCover") }}

            </b-button> -->
            <!-- พิมพ์ใบแปะจดหมาย/กล่อง -->
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="outline-secondary"
              class="mb-75"
              block
              @click="printInvoice"
            >
              {{ $t("OrderListDetails.PrintPurchaseOrder") }}
              <!-- พิมพ์ใบสั่งซื้อ -->
            </b-button>

            <!-- Button: Edit -->
            <b-button
              v-show="orderModel.orderStatusString == 'Paid'"
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              v-b-modal.modal-orderview-call
              variant="primary"
              class="mb-75"
              block
            >
              {{ $t("OrderListDetails.CallaTransport") }}
              <!-- เรียกรถขนส่ง -->
            </b-button>

            <b-button
              v-show="orderModel.orderStatusString == 'Successful Transaction' || orderModel.orderStatusString == 'Reviewed'"
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="primary"
              class="mb-75"
              block
              @click="withdrawOrder(orderModel.id)"
            >
              {{ $t("OrderListDetails.WithdrawMoney") }}
              <!-- ถอนเงิน -->
              <!-- ถอนเงิน -->
            </b-button>

            <b-button
              v-show="orderModel.orderStatusString == 'Delivery'"
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="primary"
              class="mb-75"
              block
              @click="printLabelBooking()"
            >
              {{ $t("OrderListDetails.PrintCoverSheet") }}
              <!-- พิมพ์ใบปะหน้า -->
            </b-button>
          </b-card>

          <b-card>
            <app-timeline>
              <app-timeline-item
                v-for="status in orderModel.orderHistoryStatuses"
                :key="status.orderId"
                :title="$t('OrderListDetails.OrderStatus')"
                :subtitle="status.deliveryString"
                :time="status.deliveryDateString"
                variant="success"
              />
            </app-timeline>
          </b-card>
        </b-col>
      </b-row>
    </section>
    <b-modal
      id="modal-orderview-call"
      ref="modal-user"
      centered
      :title="$t('OrderListDetails.CallaTransport')"
      size="lg"
      :ok-title="$t('OrderListDetails.CallaTransport')"
      cancel-variant="outline-secondary"
      :cancel-title="$t('OrderListDetails.Cancel')"
      :no-close-on-backdrop="true"
      @ok="confirmModal"
    >
      <b-row style="justify-content: center; display: flex">
        <b-col cols="8">
          <b-form-group
            :label="$t('OrderListDetails.ChooseBoxSize')"
            label-cols="4"
          >
            <v-select
              v-model="selectedPackage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="label"
              :options="optionsPackages"
            />
          </b-form-group>
          <b-form-group
            :label="$t('OrderListDetails.ChooseaDeliveryDate')"
            label-cols="4"
          >

            <b-form-datepicker
              id="example-datepicker"
              v-model="dateSelect"
              :min="minDate"
              class="mb-1"
              :locale="$i18n.locale"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row style="justify-content: end; display: flex">
        <b-col cols="5">
          <!-- <p>
            {{ $t("OrderListDetails.EstimatedShippingCost") }}

            ฿{{ orderModel.shippingFeeAmount.toLocaleString("en-US") }}
          </p> -->

          <p
            v-if="shippingFeeR < 0"
            style="color: red"
          >
            {{ $t("OrderListDetails.ShippingCost") }}
            <!-- ค่าจัดส่งจริง -->
            ฿{{ Math.abs(shippingFeeR).toLocaleString("en-US") }}
          </p>
          <p v-else>
            {{ $t("OrderListDetails.ShippingCost") }}
            <!-- ค่าจัดส่งจริง -->
            ฿{{ shippingFeeR.toLocaleString("en-US") }}
          </p>

          <p
            v-if="!isShippingFeeR"
            style="color: red"
          >
            กรุณาเลือกขนาดกล่องใหม่
          </p>

          <!-- <b-form-checkbox
            v-if="orderModel.shippingFeeAmount - shippingFeeR < 0"
            v-model="isConfirm"
          >
            {{
              $t("OrderListDetails.ActualShippingCost/EstimatedShippingCost")
            }}
            <br>
            {{ $t("OrderListDetails.TheDifference") }}
          </b-form-checkbox> -->
        </b-col>
      </b-row>
    </b-modal>
    <b-modal
      id="modal-cancel-order"
      ref="modal-user"
      centered
      :title="$t('OrderListDetails.Cancel')"
      size="md"
      :ok-title="$t('OrderListDetails.Confirm')"
      cancel-variant="outline-secondary"
      :cancel-title="$t('OrderListDetails.Cancel')"
      @ok="cancelOrder(orderModel.id)"
    >
      <h5>{{ $t("OrderListDetails.TextModalCancel") }}</h5>
    </b-modal>
  </div>
</template>

<script>
import { ref, onUnmounted } from '@vue/composition-api'
import store from '@/store'
// eslint-disable-next-line import/no-cycle
import router from '@/router'
import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BTableLite,
  BCardText,
  BButton,
  BLink,
  VBToggle,
  BBreadcrumb,
  BBreadcrumbItem,
  BFormGroup,
  BFormInput,
  BFormDatepicker,
  BFormCheckbox,
  BModal,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
// import InvoiceSidebarSendInvoice from './InvoiceSidebarSendInvoice.vue'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { getUserData } from '@/auth/utils'
import axios, { omsURL } from '@axios'
import fileDownload from 'js-file-download'
import orderStoreModule from './orderStoreModule'
import useOrderList from './useOrderList'

export default {
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BTableLite,
    BCardText,
    BButton,
    BLink,
    BBreadcrumb,
    BBreadcrumbItem,
    AppTimeline,
    AppTimelineItem,
    vSelect,
    BModal,
    BFormGroup,
    BFormInput,
    BFormDatepicker,
    BFormCheckbox,
    // InvoiceSidebarSendInvoice,
    ToastificationContent,
  },
  data() {
    return {
      value: '',
      selectedPackage: {},
      dateSelect: '',
      shippingFeeR: 0,
      isError: false,
      errorMessage: '',
      isConfirm: false,
      minDate: new Date(),
      isShippingFeeR: true,
      ltstBoxs: [],
    }
  },
  setup() {
    // const invoiceData = ref(null)
    // const paymentDetails = ref({})

    // Invoice Description
    // ? Your real data will contain this information
    const invoiceDescription = [
      {
        taskTitle: 'Native App Development',
        taskDescription:
          'Developed a full stack native app using React Native, Bootstrap & Python',
        rate: '$60.00',
        hours: '30',
        total: '$1,800.00',
      },
      {
        taskTitle: 'UI Kit Design',
        taskDescription:
          'Designed a UI kit for native app using Sketch, Figma & Adobe XD',
        rate: '$60.00',
        hours: '20',
        total: '$1200.00',
      },
    ]

    // Register module
    if (!store.hasModule('order')) {
      store.registerModule('order', orderStoreModule)
    }

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule('order')) store.unregisterModule('order')
    })

    const trackersList = ref([])
    store
      .dispatch('order/getSalesOrderTrackersList', { id: router.currentRoute.params.id })
      .then(response => {
        console.log('response', response)
        if (response !== null) {
          response.data.data.forEach(obj => {
            console.log('obj', obj)
            trackersList.value.push(obj)
          })
        }
      })
      .catch(error => {
        console.log(error)
      })

    const orderModel = ref({})

    store
      .dispatch('order/getOder', { id: router.currentRoute.params.id })
      .then(response => {
        orderModel.value = response.data.data
      })
      .catch(error => {
        console.log(error)
      })

    const optionsPackages = ref([{ title: '', value: '' }])

    store
      .dispatch('order/getDataPackage')
      .then(response => {
        if (response !== null) {
          response.data.data.forEach(data => {
            optionsPackages.value.push({
              value: data.package_Code,
              title: `${data.package_Name} - ${data.packageDesc_TH}`,
              packageWidth: data.package_Width,
              packageLength: data.package_Length,
              packageHeight: data.package_Height,
              packageDescTH: data.packageDesc_TH,
              packageDescEN: data.packageDesc_EN,
              label: `${data.package_Name} - ${data.packageDesc_TH} - w ${data.package_Width} - l ${data.package_Length} - h ${data.package_Height}`,
            })
          })
        }
      })
      .catch(error => {
        console.log(error)
      })

    const printInvoice = () => {
      window.print()
    }

    const { dataMap } = useOrderList()

    return {
      orderModel,
      trackersList,
      // invoiceData,
      // paymentDetails,
      invoiceDescription,
      printInvoice,
      optionsPackages,
      dataMap,
    }
  },
  watch: {
    dateSelect() {
      if (this.selectedPackage.value) {
        this.getShippingFeeAmount()
      }
    },
    selectedPackage() {
      if (this.dateSelect) {
        this.getShippingFeeAmount()
      }
    },
  },
  methods: {
    showToast(variant, icon, text) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Notification',
          icon,
          text,
          variant,
        },
      })
    },
    getShippingFeeAmount() {
      console.clear()
      this.ltstBoxs = []
      this.isShippingFeeR = true
      this.shippingFeeR = 0
      console.log('getShippingFeeAmount', this.orderModel)
      console.log('selectedPackage', this.selectedPackage)
      const itemPerBoxList = []

      this.orderModel.items.forEach(obj => {
        // console.log(obj)
        const qty = obj.quantity // 3 ชิ้น
        const modWeight = Math.floor(100 / obj.weight) // 5
        const modWidth = Math.floor(this.selectedPackage.packageWidth / obj.width) // 2
        const modHeight = Math.floor(this.selectedPackage.packageLength / obj.depth) // 2
        const modLength = Math.floor(this.selectedPackage.packageHeight / obj.height) // 2

        // console.log('qty', qty)
        // console.log('modWeight', modWeight)
        // console.log('modWidth', modWidth)
        // console.log('modHeight', modHeight)
        // console.log('modLength', modLength)

        const list = []
        list.push(modWeight)
        list.push(modWidth)
        list.push(modHeight)
        list.push(modLength)

        // console.log('list', list)

        const itemPerBox = Math.min.apply(null, list)
        itemPerBoxList.push(itemPerBox)
        console.log('itemPerBox', itemPerBox)

        if (itemPerBox > 0 && this.selectedPackage) {
          const totalBox = Math.ceil(qty / itemPerBox)
          console.log('totalBox', totalBox)
          for (let i = 0; i < totalBox; i++) {
            const parcel_Qty = (i + 1) == totalBox ? (qty % itemPerBox == 0 ? itemPerBox : qty % itemPerBox) : itemPerBox

            // productList.push({
            //   parcel_ID: this.selectedPackage.value,
            //   postal_Code_Origin: this.orderModel.shopAddressZipCode,
            //   // postal_Code_Origin: this.orderModel.shippedOn,
            //   postal_Code_Destination: this.orderModel.customerZipcode,
            //   parcel_Weight: (obj.itemWeight / qty) * parcel_Qty,
            //   parcel_Width: this.selectedPackage.packageWidth, // (obj.itemWidth / qty) * parcel_Qty,
            //   parcel_Length: this.selectedPackage.packageLength, // (obj.itemLenght / qty) * parcel_Qty,
            //   parcel_Height: this.selectedPackage.packageHeight, // (obj.itemHeight / qty) * parcel_Qty,
            //   parcel_Qty: 1,

            //   //         payload.parcel_Width = this.selectedPackage.packageWidth
            //   // payload.parcel_Length = this.selectedPackage.packageLength
            //   // payload.parcel_Height = this.selectedPackage.packageHeight

            //   // parcel_Value: this.orderModel.packageWidth,
            // })

            const payloadBox = {
              parcel_ID: this.selectedPackage.value,
              postal_Code_Origin: this.orderModel.shopAddressZipCode,
              postal_Code_Destination: this.orderModel.customerZipcode,
              parcel_Weight: (obj.itemWeight / qty) * parcel_Qty,
              parcel_Width: this.selectedPackage.packageWidth, // (obj.itemWidth / qty) * parcel_Qty,
              parcel_Length: this.selectedPackage.packageLength, // (obj.itemLenght / qty) * parcel_Qty,
              parcel_Height: this.selectedPackage.packageHeight, // (obj.itemHeight / qty) * parcel_Qty,
              parcel_Qty: 1,
            }

            const userData = getUserData()
            const payload = {
              user_ID: userData.contactId,
              pickup_Date: this.dateSelect,
              data: [payloadBox],
            }
            store
              .dispatch('order/getShippingFee', payload)
              .then(response => {
                if (response !== null) {
                  this.shippingFeeR += response.data.price_Net_Total

                  // console.log('response', response.data)

                  const result = {
                    id: obj.id,
                    orderItemId: obj.orderItemId,
                    name: obj.name,
                    unitPrice: obj.unitPrice,
                    weight: obj.weight,
                    width: obj.width,
                    height: obj.height,
                    depth: obj.depth,
                    mediaUrl: obj.mediaUrl,
                    productPrice: obj.productPrice,
                    quantity: obj.quantity,
                    discountAmount: obj.discountAmount,
                    itemAmount: obj.itemAmount,
                    itemWeight: obj.itemWeightitemWeight,
                    note: obj.note,
                    shippedQuantity: obj.shippedQuantity,
                    availableQuantity: obj.availableQuantity,
                    quantityToShip: parcel_Qty,
                    trackingID_oms: null,
                    cus_Con_no: null,
                    jobID: null,
                    itemWidth: obj.itemWidth,
                    itemLenght: obj.itemLenght,
                    itemHeight: obj.itemHeight,
                    servicePrice: response.data.price_Net_Total,
                    itemPerBox,
                    totalBox,
                    boxNo: i + 1,
                    itemInBox: parcel_Qty,
                  }

                  this.ltstBoxs.push(result)

                  const minBox = Math.min.apply(null, itemPerBoxList)
                  if (minBox == 0) {
                    this.shippingFeeR = 0
                    this.isShippingFeeR = false
                    this.ltstBoxs = []
                  }
                  // console.log('length', this.ltstBoxs.length)
                }
              })
              .catch(error => {
                console.log(error)
              })
          }
        } else {
          this.isShippingFeeR = false
        }
      })
    },
    async confirmModal() {
      const valueFilter = await this.dataMap.filter(
        data => data.Province_Name == this.orderModel.shippingAddress.province
          && data.Amphoe_Name == this.orderModel.shippingAddress.amphur
          && data.Tambon_Name == this.orderModel.shippingAddress.tumbon,
      )

      const payload = this.orderModel
      payload.shippingAddress.gps_lat = (valueFilter[0] && valueFilter[0].gps_lat.toString()) || ''
      payload.shippingAddress.gps_long = (valueFilter[0] && valueFilter[0].gps_long.toString()) || ''
      payload.priceNetTotal = this.shippingFeeR
      payload.shippingFeeAmount = this.shippingFeeR
      this.shippingFeeR > this.orderModel.shippingFeeAmount
        ? this.shippingFeeR
        : this.orderModel.shippingFeeAmount
      payload.deliveredOn = this.dateSelect

      payload.parcel_Weight = 100
      payload.parcel_Width = this.selectedPackage.packageWidth
      payload.parcel_Length = this.selectedPackage.packageLength
      payload.parcel_Height = this.selectedPackage.packageHeight

      payload.items = this.ltstBoxs

      console.log(payload)

      store
        .dispatch('order/getLTLCreateOrder', payload)
        .then(response => {
          if (response !== null) {
            store
              .dispatch('order/getOder', { id: router.currentRoute.params.id })
              .then(response => {
                this.orderModel = response.data.data
                this.getSalesOrderTrackersList(router.currentRoute.params.id)

                //
              })
              .catch(error => {
                console.log(error)
              })
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    getSalesOrderTrackersList(id) {
      this.trackersList = []
      store
        .dispatch('order/getSalesOrderTrackersList', { id })
        .then(response => {
          console.log('response', response)
          if (response !== null) {
            response.data.data.forEach(obj => {
              console.log('obj', obj)
              this.trackersList.push(obj)
            })
          }
        })
        .catch(error => {
          console.log(error)
        })
    },

    cancelOrder(id) {
      store
        .dispatch('order/cancelOrder', { id })
        .then(response => {
          if (response.data.success) {
            this.$router.push({ name: 'order-list' }).then(() => {
              this.showToast('success', 'CheckIcon', 'Saved Successfully.')
            })
          } else {
          }
        })
        .catch(error => {
          this.showToast('danger', 'XCircleIcon', error)
        })
    },

    withdrawOrder(id) {
      store
        .dispatch('order/withdrawOrder', { id })
        .then(response => {
          //console.log(response)
          //console.log(response.data.errorMsg)
          if (response.status === 200) {
            if (response.data.errorMsg === '' || response.data.errorMsg === null) {
              this.showToast('success', 'CheckIcon', 'Success.')
            } else {
              this.showToast('danger', 'XCircleIcon', response.data.errorMsg)
            }
          }
        })
        .catch(error => {
          if (error.response.data === "User don't set default account id") {
            this.showToast('danger', 'XCircleIcon', 'ไม่พบบัญชีธนาคาร')
            router.push({ name: 'my-bank' })
          } else if (error.response.data === 'Address not found') {
            this.showToast('danger', 'XCircleIcon', 'ข้อมูลที่อยู่ไม่ถูกต้อง')
            router.push({ name: 'shop-home' })
          } else {
            this.showToast('danger', 'XCircleIcon', error)
          }
        })
    },
    printLabel(item) {
      console.log('item', item)
      const token = 'bG9hZGJvYXJkVXNyOjU0MzQ1Mw=='

      const data = {
        userID: this.orderModel.userIdOMS, // 'M000000245'
        projectName: '',
        trackingID: item.item.trackingID_oms, // 'LT000005524DB'
      }

      // https://uat-oms-api.azurewebsites.net/api/GetDataPackage
      // https://oms-api.promptsong.co/api/GetDataPackage

      const headers = {
        responseType: 'blob',
        Authorization: `Bearer ${token}`,
        Channel: 'MarketPlaceDEWeb',
      }

      axios
        .post(`${omsURL}/api/APIPrintLabel`, data, headers)
        .then(response => {
          console.log(response)
          console.log(response.data)
          fileDownload(response.data, `ใบปะหน้า ${this.orderModel.trackingID_oms}.pdf`)
        })
        .catch(error => {
          console.log(error)
        })
    },
    printLabelBooking() {
      const token = 'bG9hZGJvYXJkVXNyOjU0MzQ1Mw=='

      const data = {
        userID: this.orderModel.userIdOMS, // 'M000000245'
        projectName: '',
        bookingID: this.orderModel.trackingID, // 'LT000005524DB'
      }

      const headers = {
        responseType: 'blob',
        Authorization: `Bearer ${token}`,
        Channel: 'MarketPlaceDEWeb',
      }

      axios
        .post(`${omsURL}/api/APIPrintBookingLabel`, data, headers)
        .then(response => {
          console.log(response)
          console.log(response.data)
          fileDownload(response.data, `ใบปะหน้า ${this.orderModel.trackingID}.pdf`)
        })
        .catch(error => {
          console.log(error)
        })
    },
    GetStatusName(status) {
      if (status == 50) {
        return 'กำลังจัดส่ง'
      }
      if (status == 60) {
        return 'จัดส่งสำเร็จ'
      }
      return ''
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
</style>

<style lang="scss">
@media print {
  // Global Styles
  body {
    background-color: transparent !important;
  }
  nav.header-navbar {
    display: none;
  }
  .main-menu {
    display: none;
  }
  .header-navbar-shadow {
    display: none !important;
  }
  .content.app-content {
    margin-left: 0;
    padding-top: 2rem !important;
  }
  footer.footer {
    display: none;
  }
  .card {
    background-color: transparent;
    box-shadow: none;
  }
  .customizer-toggle {
    display: none !important;
  }

  // Invoice Specific Styles
  .invoice-preview-wrapper {
    .row.invoice-preview {
      .col-md-8 {
        max-width: 100%;
        flex-grow: 1;
      }

      .invoice-preview-card {
        .card-body:nth-of-type(2) {
          .row {
            > .col-12 {
              max-width: 50% !important;
            }

            .col-12:nth-child(2) {
              display: flex;
              align-items: flex-start;
              justify-content: flex-end;
              margin-top: 0 !important;
            }
          }
        }
      }
    }

    // Action Right Col
    .invoice-actions {
      display: none;
    }
  }
}
</style>
